module.exports = __webpack_public_path__ + "static/media/light-theme-drop-arrow.e5823ee6.svg";